module.exports = __webpack_public_path__ + "img/connections-woman.ee1e30de.png";